import type { Action } from '../types/action.dto';
import type { ActionModel } from '../types/action.model';

export const toActionModel = (dto: Action): ActionModel => {
	return {
		id: dto.id!,
		title: dto?.content?.title?.text ?? '',
		body: dto?.content?.body?.text ?? '',
		organizationId: dto.org_id!,
		sendTime: dto?.opts?.send_time,
		status: dto?.data?.status,
		recipientGroups: dto?.recipient_groups?.map((group) => ({
			groupNumber: group.group_number,
			recipients: group.recipients?.map((recipient) => ({
				id: recipient.id,
				type: recipient.type,
			})),
		})),
	};
};
